<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="移库单号" prop="moveNo">
        <el-input v-model.trim="queryParams.moveNo" placeholder="请输入移库单号" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="原始仓库" prop="oldWareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" clearable :props="defaultProps"
          v-model="queryParams.oldWareHouseId" @change="handleQuery" placeholder="请选择原始仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="目标仓库" prop="targetWareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" clearable :props="defaultProps"
          v-model="queryParams.targetWareHouseId" @change="handleQuery" placeholder="请选择目标仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="移库类型" prop="moveType">
        <el-select-dict dictType="MOVE_TYPE" clearable placeholder="请选择移库类型" v-model="queryParams.moveType"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="移库状态" prop="moveStatus">
        <el-select-dict dictType="MOVE_STATUS" clearable placeholder="请选择移库状态" v-model="queryParams.moveStatus"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>

      <el-form-item class="search-field fl" label="渠道" prop="channel">
        <el-select-dict dictType="CHANNEL" clearable placeholder="请选择渠道" v-model="queryParams.channel"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['inventory:move:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['inventory:move:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['inventory:move:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="moveTable" :class="{ empty: list.length === 0 }" empty-text=" " v-loading="loading" :data="list"
          row-key="moveId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55"
            align="center" />
          <el-table-column label="移库单号" prop="moveNo" align="center" min-width="168px">
            <template slot-scope="scope">
              <el-link v-if="mixinHasPermi(['inventory:record:list']) && scope.row.moveStatus === '1'" type="primary"
                @click="mixinHandleGoRecordList(scope.row.moveNo)">{{ scope.row.moveNo }}</el-link>
              <span v-else>{{ scope.row.moveNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="原始仓库" prop="oldWareHouseIdList" align="center" min-width="168px" show-overflow-tooltip="">
            <template slot-scope="scope">
              <span>{{ getWareHouseNameByList(scope.row.oldWareHouseIdList) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="目标仓库" prop="targetWareHouseIdList" align="center" min-width="168px" show-overflow-tooltip="">
            <template slot-scope="scope">
              <span>{{ getWareHouseNameByList(scope.row.targetWareHouseIdList) }}</span>
            </template>
          </el-table-column>
          <el-table-column-dict dictType="MOVE_TYPE" label="移库类型" prop="moveType" align="center" min-width="120px" />
          <el-table-column-dict dictType="MOVE_STATUS" dictTypeNode="tag" label="移库状态" align="center" prop="moveStatus"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="channel"
            min-width="100px"></el-table-column-dict>
          <el-table-column label="操作人" prop="creator.userName" align="center" min-width="168px" show-overflow-tooltip>
            <template slot-scope="scope">
              创建人：{{ scope.row.creator.userName }}<br />
              更新人：{{ scope.row.updater.userName }}
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              创建时间：{{ scope.row.createTime | formatDate("datetime") }}<br />
              更新时间：{{ scope.row.updateTime | formatDate("datetime") }}
            </template>
          </el-table-column>
          <el-table-column v-if="
            mixinHasPermi([
              'inventory:move:read',
              'inventory:move:delete',
            ])
          " label="操作" align="center" width="228px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button size="mini" v-hasPermission="['inventory:move:read']" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button :disabled="scope.row.moveStatus === '1'" v-hasPermission="['inventory:move:delete']" size="mini"
                type="danger" icon="el-icon-delete" title="已移库的移库单不可删除"
                @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
    <move-dialog ref="moveDialog" :visible.sync="open" :modal-append-to-body="false" :close-on-click-modal="false"
      :isUpdate="isUpdate" :baseForm="baseForm" @close="open = false" @successs="init" :wareHouseData="wareHouseData"  width="1280px"></move-dialog>
  </div>
</template>

<script>
import MoveDialog from "./components/move-dialog.vue"
import { moveApi, wareHouseApi } from "@/api"
import {markNonLeafNodes} from "@/utils/tree"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
export default {
  name: "inventoryMoveManage",
  components: {
    MoveDialog
  },
  data() {
    return {
      wareHouseData: [], // 仓库树 数据
      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      selection: [], // 选中的列表数据
      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        moveNo: "", // 移库单号
        targetWareHouseId: "",
        oldWareHouseId: "",
        moveType: "", // 移库类型
        moveStatus: "", // 配置项状态
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      loading: false,
      total: 0,
      open: false,
      // 表单参数
      baseForm: {
        moveType: "", // 
        moveStatus: "", // 
        remark: "" // 备注
      }

    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          moveType: "", // 
          moveStatus: "", // 
          remark: "" // 备注
        }
        this.$refs.moveDialog && this.$refs.moveDialog.resetForm()
      }
    }
  },
  async created() {
    const { query } = this.$route
    if (query.operateNo || query.billNo) {
      this.queryParams.moveNo = query.operateNo || query.billNo
    }
    await this.init()
  },
  methods: {
    // 初始化
    async init() {
      await this.getWareHouseTree()
      //获取列表
      this.getList()
    },
    // 通过仓库id数组 返回仓库名字
    getWareHouseNameByList(wareHouseIdList) {
      const wareHouseNameList = []
      for (let i = 0; i < wareHouseIdList.length; i++) {
        const wareHouseId = wareHouseIdList[i]
        const name = this.getWareHouseName(wareHouseId)
        wareHouseNameList.push(name)
      }
      return wareHouseNameList.join("；")
    },
    // 获取仓库名字
    getWareHouseName(val) {
      if (!val) {
        return ""
      }
      const wareHouseId = Array.isArray(val) ? val[val.length - 1] : val
      const list = getPathByTreeValue(this.wareHouseData, wareHouseId, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 获取仓库列表
    getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = markNonLeafNodes(data, this.$store.getters.wareHouseIdList, {idField: "wareHouseId"})
      })
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()
            
      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.moveId)
        str += item.moveNo
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }
      this.$modal
        .confirm('删除后将无法找回！是否确认删除移库单号为"【' + str + '】"的数据项？')
        .then(function() {
          return moveApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除移库单成功")
        })
    },
    // 已出库的 禁止操作
    checkSelectable(row, index) {
      if (row.moveStatus === "1") {
        return false
      } else {
        return true
      }
    },
    //点击行
    clickRow(row) {
      //已入库的 不做处理
      if (row.outStatus === "1") {
        return
      }
      this.$refs.moveTable.toggleRowSelection(row)
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      // 库存单号重置
      this.queryParams.moveNo = ""
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      // 清空所有选中的数据
      this.$refs.moveTable && this.$refs.moveTable.clearSelection()
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.queryParams))
      params.oldWareHouseId = (Array.isArray(params.oldWareHouseId) ? params.oldWareHouseId[params.oldWareHouseId.length - 1] : params.oldWareHouseId) || null
      params.targetWareHouseId = (Array.isArray(params.targetWareHouseId) ? params.targetWareHouseId[params.targetWareHouseId.length - 1] : params.targetWareHouseId) || null
      moveApi
        .getList(this.mixinAddDateRange(params, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.moveId) {
        this.isUpdate = true
      }
      const id = row.moveId || (this.selection[0] && this.selection[0].moveId)
      moveApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()
            
      const id = row.moveId
      this.$modal
        .confirm('删除后将无法找回！是否确认删除移库单号为"' + row.moveNo + '"的数据项？')
        .then(function() {
          return moveApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.moveId === id)
          flag && this.$refs.moveTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    }
  }
}
</script>